import React, { Component, useCallback, useMemo } from "react";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  IconButton,
  FormControlLabel,
  Checkbox,
  TextField,
} from "@material-ui/core";
import SystemUpdateAltIcon from "@material-ui/icons/SystemUpdateAlt";
import SnackBarComponent from "../../SnackBar/SnackBar";
import cloudUploadIcon from "../../assets/images/Icon feather-upload-cloud.svg";
import { useDropzone } from "react-dropzone";
import "./editpatient.css";
import {
  getCtScanData,
  saveCTScan,
  getEmailTemplate,
  ctscanRequestIP3,
  allTreatmentHistories,
  CtscansUploadPA,
  CtscansUploadTP,
} from "./PatientQuery";
import { fetchMethod, formatDate } from "../../FetchMethod";
import { FadeLoader } from "react-spinners";
import { mutationQueries } from "../../MutationMethod";
import { URLDATA } from "../../Config";
import TreatMentHistorySection from "./TreatMentHistorySection";
import CloseIcon from "@material-ui/icons/Close";
import store from "../../Redux/Store";
import EmailTemplateEditor from "../Email/EmailTemplateEditor";
import CircularProgressWithLabel from "../../DumbAssets/CircularProgress";
function Dropzone(props) {
  const onDrop = useCallback((files) => {
    props.fileData(files);
  });
  const activeStyle = {
    backgroundColor: "#79B3C6",
  };
  const {
    getRootProps,
    getInputProps,
    open,
    acceptedFiles,
    fileRejections,
    isDragActive,
    isDragAccept,
    isDragReject,
  } = useDropzone({
    // Disable click and keydown behavior
    noClick: true,
    noKeyboard: true,
    onDrop,
    multiple: false,
    accept: ".pdf",
    maxSize: 100000000,
  });
  const style = useMemo(
    () => ({
      ...(isDragActive ? activeStyle : {}),
    }),
    [isDragActive, isDragReject, isDragAccept]
  );
  const files = acceptedFiles.map((file) => (
    <li key={file.path}>
      <span>
        {file.path} - {file.size} bytes
      </span>{" "}
      <IconButton
        onClick={(e) => {
          acceptedFiles.splice(acceptedFiles.indexOf(file), 1);
          props.fileData("");
        }}
      >
        <CloseIcon />
      </IconButton>
    </li>
  ));
  const fileRejectionItems = fileRejections.map(({ file, errors }) => (
    <li key={file.path}>
      <ul>
        {errors.map((e) => (
          <li key={e.code} style={{ color: "red" }}>
            {e.code === "file-too-large"
              ? "File is too large. The maximum file size should be 100 MB."
              : "File type must be pdf"}
          </li>
        ))}
      </ul>
    </li>
  ));
  return (
    <div className="container">
      <div {...getRootProps({ className: "dropzone", style })}>
        <input {...getInputProps()} accept=".pdf" />
        <img src={cloudUploadIcon} />
        <p>Drag & Drop file here</p>
        <p>or</p>
        <Button onClick={open}>Browse File</Button>
      </div>
      {files.length ? (
        <div className="fileContainer">
          {/* <h4>Files</h4> */}
          <ul>{files}</ul>
        </div>
      ) : (
        ""
      )}
      {fileRejectionItems.length ? (
        <div className="fileContainer">
          {/* <h4>Files</h4> */}
          <ul>{fileRejectionItems}</ul>
        </div>
      ) : (
        ""
      )}
    </div>
  );
}
function DownloadAndDelete(props) {
  return (
    <div className="fileData">
      <span>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="62.65"
          height="68.208"
          viewBox="0 0 62.65 68.208"
        >
          <g
            id="Group_517"
            data-name="Group 517"
            transform="translate(-174 -350)"
          >
            <path
              id="Path_120"
              data-name="Path 120"
              d="M3.031,0H38.143L50.019,12.944V65.177a3.031,3.031,0,0,1-3.031,3.031H3.031A3.031,3.031,0,0,1,0,65.177V3.031A3.031,3.031,0,0,1,3.031,0Z"
              transform="translate(186.631 350)"
              fill="#69bafe"
            />
            <rect
              id="Rectangle_258"
              data-name="Rectangle 258"
              width="42"
              height="19"
              rx="9.5"
              transform="translate(174 354)"
              fill="#0071ce"
            />
            <text
              id="DICOM"
              transform="translate(183 367)"
              fill="#fff"
              fontSize="9"
              fontFamily="KlavikaLight-OSF, Klavika"
            >
              <tspan x="0" y="0">
                PDF
              </tspan>
            </text>
            <path
              id="Path_121"
              data-name="Path 121"
              d="M0,0,12.126,13.136H3.537A3.537,3.537,0,0,1,0,9.6Z"
              transform="translate(224.524 350)"
              fill="#0071ce"
            />
            <g
              id="Icon_feather-refresh-cw"
              data-name="Icon feather-refresh-cw"
              transform="translate(201.788 384.357)"
            >
              <path
                id="Path_122"
                data-name="Path 122"
                d="M30.857,6v5.357H25.5"
                transform="translate(-11.214 -5.109)"
                fill="none"
                stroke="#fff"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="3"
              />
              <path
                id="Path_123"
                data-name="Path 123"
                d="M1.5,26.357V21H6.857"
                transform="translate(-1.5 -11.18)"
                fill="none"
                stroke="#fff"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="3"
              />
              <path
                id="Path_124"
                data-name="Path 124"
                d="M3.741,9.859a8.036,8.036,0,0,1,13.26-3l4.143,3.893M1.5,14.323l4.143,3.893a8.036,8.036,0,0,0,13.26-3"
                transform="translate(-1.5 -4.503)"
                fill="none"
                stroke="#fff"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="3"
              />
            </g>
          </g>
        </svg>
      </span>
      <div className="DicomFileviewSection">
        <ul>
          <li>{props.filename}</li>
          <li>Created on {props ? props.createdOn : ""}</li>
        </ul>
        <ul>
          <li>
            {" "}
            {props.progressValue ? (
              <div className="downloadlink">
                {/* <SystemUpdateAltIcon /> */}
                <CircularProgressWithLabel /> Downloading
              </div>
            ) : (
              <a
                onClick={(e) =>
                  props.fileDownload(
                    e,
                    props.filepath,
                    props.type,
                    props.filename
                  )
                }
                className="downloadlink"
              >
                <SystemUpdateAltIcon /> Download
              </a>
            )}
          </li>
          {props.isActionPermission ? (
            <li>
              <div
                onClick={props.handleModal}
                className="deletelink"
                // id="preliminaryanalysispath"
                id={props.id}
              >
                <span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    height="16px"
                    viewBox="-40 0 427 427.00131"
                    width="16px"
                  >
                    <path d="m232.398438 154.703125c-5.523438 0-10 4.476563-10 10v189c0 5.519531 4.476562 10 10 10 5.523437 0 10-4.480469 10-10v-189c0-5.523437-4.476563-10-10-10zm0 0" />
                    <path d="m114.398438 154.703125c-5.523438 0-10 4.476563-10 10v189c0 5.519531 4.476562 10 10 10 5.523437 0 10-4.480469 10-10v-189c0-5.523437-4.476563-10-10-10zm0 0" />
                    <path d="m28.398438 127.121094v246.378906c0 14.5625 5.339843 28.238281 14.667968 38.050781 9.285156 9.839844 22.207032 15.425781 35.730469 15.449219h189.203125c13.527344-.023438 26.449219-5.609375 35.730469-15.449219 9.328125-9.8125 14.667969-23.488281 14.667969-38.050781v-246.378906c18.542968-4.921875 30.558593-22.835938 28.078124-41.863282-2.484374-19.023437-18.691406-33.253906-37.878906-33.257812h-51.199218v-12.5c.058593-10.511719-4.097657-20.605469-11.539063-28.03125-7.441406-7.421875-17.550781-11.5546875-28.0625-11.46875h-88.796875c-10.511719-.0859375-20.621094 4.046875-28.0625 11.46875-7.441406 7.425781-11.597656 17.519531-11.539062 28.03125v12.5h-51.199219c-19.1875.003906-35.394531 14.234375-37.878907 33.257812-2.480468 19.027344 9.535157 36.941407 28.078126 41.863282zm239.601562 279.878906h-189.203125c-17.097656 0-30.398437-14.6875-30.398437-33.5v-245.5h250v245.5c0 18.8125-13.300782 33.5-30.398438 33.5zm-158.601562-367.5c-.066407-5.207031 1.980468-10.21875 5.675781-13.894531 3.691406-3.675781 8.714843-5.695313 13.925781-5.605469h88.796875c5.210937-.089844 10.234375 1.929688 13.925781 5.605469 3.695313 3.671875 5.742188 8.6875 5.675782 13.894531v12.5h-128zm-71.199219 32.5h270.398437c9.941406 0 18 8.058594 18 18s-8.058594 18-18 18h-270.398437c-9.941407 0-18-8.058594-18-18s8.058593-18 18-18zm0 0" />
                    <path d="m173.398438 154.703125c-5.523438 0-10 4.476563-10 10v189c0 5.519531 4.476562 10 10 10 5.523437 0 10-4.480469 10-10v-189c0-5.523437-4.476563-10-10-10zm0 0" />
                  </svg>
                </span>{" "}
                Delete
              </div>
            </li>
          ) : (
            ""
          )}
        </ul>
      </div>
      <div className="commentSection">
        {/* {CtscanData ?CtscanData.comments ?} */}
        <span>Comments</span>
        <p>{props.comments ? props.comments : ""}</p>
      </div>
    </div>
  );
}
class EditPatient extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      open: false,
      severity: "",
      alertmsg: "",
      files: "",
      timer: 2000,
      treatmentfile: "",
      CtscanData: undefined,
      deleteModalOpen: false,
      treatmentHistoryAddOpen: false,
      treatmentHistoryEditOpen: false,
      isActionPermission: store.getState().Permission
        ? store.getState().Permission.USER_SITE_FILE_PERMISSION
        : false,
      isEmailModalDialog: false,
      notificationModalOpen: false,
    };
  }

  UNSAFE_componentWillMount() {
    return this.props.location.state
      ? this.getFormData()
      : this.props.history.push("/patients");
  }

  //Edit Treatment History open
  renderTreatmentHistoryEdit = (Add, Edit) => {
    if (Add) {
      this.getTreatmentHistory();
      this.setState({
        treatmentHistoryAddOpen: !this.state.treatmentHistoryAddOpen,
      });
    } else if (!Add && Edit) {
      this.setState({
        treatmentHistoryAddOpen: false,
      });
    } else
      this.setState({
        treatmentHistoryAddOpen: !this.state.treatmentHistoryAddOpen,
      });
  };

  getFormData = () => {
    // console.log("------CTSCAN ID ---", this.props.location.state.id);

    fetchMethod(getCtScanData(this.props.location.state.id))
      .then((res) => res.json())
      .then((res) => {
        let singleCtScanData = res.data.allCtscans.Ctscans[0];
        singleCtScanData.filename = singleCtScanData.filepath
          ? singleCtScanData.filepath.replace(/^.*[\\\/]/, "")
          : "";
        singleCtScanData.scandate = singleCtScanData.scandate
          ? formatDate(singleCtScanData.scandate)
          : "";
        singleCtScanData.preliminary = singleCtScanData.preliminaryanalysispath
          ? singleCtScanData.preliminaryanalysispath.replace(/^.*[\\\/]/, "")
          : "";
        let treatmentfileName = singleCtScanData.treatmentplanpath
          ? singleCtScanData.treatmentplanpath.replace(/^.*[\\\/]/, "")
          : "";
        this.setState({
          CtscanData: singleCtScanData,
          loading: false,
          treatmentfileName,
        });
      })
      .catch((e) => {
        this.setState({ loading: false });
        console.log(e);
      });
    this.getTreatmentHistory();
  };

  getTreatmentHistory = async () => {
    let response = await fetchMethod(allTreatmentHistories, {
      where: {
        ctscanid: this.props.location.state.id, //this.props.location.state.id
        active: 1,
      },
    }).then((res) => res.json());
    let {
      data: {
        allTreatmenthistories: { Treatmenthistories },
      },
    } = response;
    // console.log("====rES", response);
    this.setState({ treatmentHistoryData: Treatmenthistories });
  };

  Patients = () => {
    this.props.history.push("/patients");
  };
  onDrop = (acceptedFile) => {
    console.log("e.target.file", acceptedFile);
  };

  fileData = (file) => {
    if (file && file.length) {
      file[0]["preview"] = URL.createObjectURL(file[0]);
      this.handleFileUpload(file, "preliminaryFilename");
    }
    this.setState({
      files: file,
    });
  };
  fileTreatmentData = (file) => {
    if (file && file.length) {
      file[0]["preview"] = URL.createObjectURL(file[0]);
      this.handleFileUpload(file, "ip3Filename");
    }
    this.setState({
      treatmentfile: file,
    });
  };
  handleFileUpload = async (files, filename) => {
    if (files) {
      let formData = new FormData();
      formData.append("ctscan", files[0]);
      let that = this;
      let issuccess = false;
      var requestOptions = {
        method: "POST",
        body: formData,
        redirect: "follow",
        headers: {
          access_token: localStorage.getItem("token"),
        },
      };
      this.setState({ loading: true });
      return await fetch(URLDATA.cturl, requestOptions)
        .then((response) => response.json())
        .then((res) => {
          if (res.result && res.result.files) {
            if (res.result.files.ctscan.length) {
              this.setState({
                loading: false,
                [filename]: res.result.files.ctscan[0].name,
              });
            }
          } else {
            let message = res.error ? res.error.message : res.message;
            that.setState({
              open: true,
              severity: "error",
              alertmsg: message,
              loading: false,
              timer: 3000,
            });

            issuccess = false;
          }
          return issuccess;
        })
        .catch((error) => {
          that.setState({
            open: true,
            severity: "error",
            alertmsg: error.message,
            loading: false,
            isFileUpload: false,
            saveButtonDisabled: false,
            timer: 3000,
          });
          issuccess = false;
          return issuccess;
        });
    }
  };
  savePreliminary = async () => {
    let {
      files,
      CtscanData,
      treatmentfile,
      sendEmail,
      message,
      preliminaryFilename,
      ip3Filename,
      sendAndSave,
      preliminaryComment,
      requestip3comments,
    } = this.state;
    this.setState({ loading: true });
    if (files || treatmentfile) {
      let url = "";
      let requestObj = {};
      let filename = "";
      let comments = "";
      if (files && preliminaryFilename) {
        url = CtscansUploadPA;
        filename = preliminaryFilename;
        comments = preliminaryComment;
      } else {
        url = CtscansUploadTP;
        filename = ip3Filename;
        comments = requestip3comments;
      }
      if (sendEmail && !sendAndSave) {
        this.getEmailDetails();
        this.setState({
          isEmailModalDialog: true,
        });
      } else {
        requestObj = {
          uniqueId: CtscanData.id,
          emailMessage: message ? message : "",
          filename,
          comments: comments,
        };
        this.setState({ isEmailModalDialog: false });
        let that = this;
        let issuccess = false;
        mutationQueries(url, requestObj)
          .then((res) => {
            if (
              res.data.CtscansUploadPA
                ? res.data.CtscansUploadPA.status === "success"
                : res.data.CtscansUploadTP.status === "success"
            ) {
              this.setState(
                {
                  isFileUpload: true,
                  open: true,
                  severity: "success",
                  alertmsg: res.data.CtscansUploadPA
                    ? res.data.CtscansUploadPA.message
                    : res.data.CtscansUploadTP.message,
                  timer: 2000,
                  loading: false,
                  saveButtonDisabled: true,
                  closeModal: true,
                },
                () => {
                  setTimeout(() => {
                    this.props.history.push("/patients");
                  }, 2000);
                }
              );

              issuccess = true;
            } else {
              let message = res.data.CtscansUploadPA.message;
              that.setState({
                open: true,
                severity: "error",
                alertmsg: message,
                loading: false,
                isFileUpload: false,
                saveButtonDisabled: false,
              });
              issuccess = false;
            }
            return issuccess;
          })
          .catch((error) => {
            that.setState({
              open: true,
              severity: "error",
              alertmsg: error.message,
              loading: false,
              isFileUpload: false,
              saveButtonDisabled: false,
            });
            issuccess = false;
            return issuccess;
          });
      }
    }
  };
  deleteFile = (e) => {
    let { filename, ...CtscanData } = this.state.CtscanData;
    const { deleteFileType } = this.state;
    let obj = {};
    if (deleteFileType === "ctscan") {
      CtscanData.active = 0;
    } else {
      CtscanData[deleteFileType] = null;
      deleteFileType === "preliminaryanalysispath"
        ? (CtscanData.preliminaryanalysiscomments = null)
        : (CtscanData.treatmentplancomments = null);
    }
    delete CtscanData.preliminary;
    mutationQueries(saveCTScan, { obj: { ...CtscanData } })
      .then((res) => {
        if (res.data.saveCtscans.active === 0) {
          this.handleModal();
          setTimeout(() => {
            this.props.history.push("/patients");
          }, 500);
        } else {
          this.setState((prevState) => {
            return {
              deleteModalOpen: !prevState.deleteModalOpen,
              open: true,
              severity: "success",
              alertmsg: "File Deleted Successfully.",
            };
          });
        }
      })
      .catch((err) => {
        console.log(err, "Error");
      });
  };
  handleModal = (e) => {
    const { id } = e ? e.target : "";
    this.setState((prevState) => {
      console.log("--previousState--", !prevState.deleteModalOpen);
      return {
        deleteModalOpen: !prevState.deleteModalOpen,
        deleteFileType: id,
      };
    });
  };
  handleSnackBarClose = () => {
    let { severity } = this.state;
    this.setState({ open: false, severity: "", alertmsg: "" });
    if (severity === "success") {
      this.props.history.push("/patients");
    }
  };
  fileDownload = (e, filepath, type, filename) => {
    let url = "";
    let fileType = "";
    let progressValue = {};
    if (type === "ctscan") {
      url = `${URLDATA.ctdownload}?tag=ctscan&filePath=${
        filepath ? filepath : ""
      }`;

      // fileType = "application/dicom";
      fileType = "application/zip";
      progressValue = {
        ctscan: true,
        preliminary: false,
        ip3: false,
      };
    } else if (type === "preAnalysis") {
      url = `${URLDATA.ctdownload}?tag=preAnalysis&filePath=${
        filepath ? filepath : ""
      }`;
      fileType = "application/pdf";
      progressValue = {
        ctscan: false,
        preliminary: true,
        ip3: false,
      };
    } else if (type === "treatmentPlan") {
      url = `${URLDATA.ctdownload}?tag=treatmentPlan&filePath=${
        filepath ? filepath : ""
      }`;
      fileType = "application/pdf";
      progressValue = {
        ctscan: false,
        preliminary: false,
        ip3: true,
      };
    }
    var requestOptions = {
      method: "GET",
      headers: {
        access_token: localStorage.getItem("token"),
      },
    };
    this.setState({ progressValue: progressValue });
    fetch(url, requestOptions)
      .then((res) => res.arrayBuffer())
      .then((response) => {
        let data = type === "ctscan" ? new Uint8Array(response) : response;
        let file = new Blob([data], { type: fileType });
        let fileURL = URL.createObjectURL(file);
        let link = document.createElement("a");
        link.href = fileURL;
        this.setState({ progressValue: false });
        link.download = filename;
        link.click();
      })
      .catch((e) => console.log(e));
  };
  handleCheck = (e) => {
    let { name, id } = e.target;
    this.setState((prevState) => {
      return {
        [name]: !prevState[name],
        emailTemplateId: id === "ip3" ? 6 : 9,
      };
    });
  };
  emailModalClose = () => {
    this.setState((prevState) => {
      return {
        isEmailModalDialog: !prevState.isEmailModalDialog,
        loading: false,
      };
    });
  };
  getEmailDetails = () => {
    const { CtscanData } = this.state;
    fetchMethod(getEmailTemplate, {
      id: this.state.emailTemplateId,
      siteid: CtscanData ? CtscanData.siteid : "",
    })
      .then((res) => res.json())
      .then((res) => {
        if (res.data.Emailtemplate) {
          let msg = res.data.Emailtemplate.message;
          let { intervaporid, scanseriesuid, acquisitiondate } = CtscanData;
          const { name } = res.data.Site ? res.data.Site : {};
          acquisitiondate = formatDate(acquisitiondate, "YYYY-MM-DD");
          const receiptdate = formatDate(new Date(), "YYYY-MM-DD");
          let file = new Blob(
            this.state.files ? this.state.files : this.state.treatmentfile,
            { type: "application/pdf" }
          );
          let fileURL = URL.createObjectURL(file);
          // msg += `<br/><a href=${fileURL} style="pointer-events: none; display: inline-block;" >${
          //   this.state.files
          //     ? "Preliminary Analysis Report"
          //     : "Treatment Analysis Report"
          // }</a>`;
          msg = msg
            .toString()
            .replace(/{{InterVaporID}}/g, intervaporid)
            .replace(/{{SiteName}}/g, name ? name : "")
            .replace(/{{SeriesUID}}/g, scanseriesuid)
            .replace(/{{CTAqDate}}/g, acquisitiondate)
            .replace(/{{CTReceiptDate}}/g, receiptdate);
          res.data.Emailtemplate.message = msg;
          this.setState({
            message: msg,
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  // For Email Template message setup
  setTemplateObject = (obj) => {
    this.setState({
      message: obj.message,
    });
  };
  //  ip3 treatment plan
  sendNotificaion = (e) => {
    let { CtscanData, ip3requestcomment } = this.state;
    let ctid = CtscanData ? CtscanData.id : "";
    mutationQueries(ctscanRequestIP3, { ctId: ctid })
      .then((res) => {
        if (res.data.CtscansRequestIP3.status === "success") {
          this.setState(
            {
              open: true,
              severity: "success",
              // alertmsg: res.data.CtscansRequestIP3.message,
              timer: 2000,
              loading: false,
              alertmsg: "IP3 request sent successfully",
            },
            () => this.getFormData()
          );
        } else {
          this.setState({
            open: true,
            severity: "error",
            alertmsg: res.data.CtscansRequestIP3.message,
            timer: 3000,
            loading: false,
            saveButtonDisabled: false,
          });
        }
      })
      .catch((err) => {
        this.setState({
          open: true,
          severity: "error",
          alertmsg: err.message,
          timer: 3000,
          loading: false,
          saveButtonDisabled: false,
        });
      });
  };
  sendNotificaionModal = (e) => {
    this.setState((prevState) => {
      return { notificationModalOpen: !prevState.notificationModalOpen };
    });
  };
  // comment text field handle
  handleCommentTextField = (e) => {
    let {
      target: { name, value },
    } = e;
    this.setState({ [name]: value });
  };
  render() {
    let { CtscanData } = this.state;
    return (
      // style={{background:"salmon"}}
      <div className="EditCTUpload">
        {this.state.loading ? (
          <div className="Loader">
            <FadeLoader
              style={{ height: "15", width: "5", radius: "2" }}
              color={"#6FABF0"}
              loading={this.state.loading}
            />
          </div>
        ) : (
          ""
        )}
        {this.state.open ? (
          <SnackBarComponent
            severity={this.state.severity}
            open={this.state.open}
            alertmsg={this.state.alertmsg}
            timer={this.state.timer}
            handleClose={this.handleSnackBarClose}
            className="addUserSnackBar"
          />
        ) : (
          ""
        )}
        <ul className="uploadpath">
          <li onClick={this.Patients} style={{ cursor: "pointer" }}>
            Patients
          </li>
          <li>
            <span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="13.992"
                height="8"
                viewBox="0 0 13.992 8"
              >
                <defs></defs>
                <path
                  className="a"
                  d="M13.186,16.835l5.291-5.295a1,1,0,0,1,1.412,0,1.008,1.008,0,0,1,0,1.416l-5.995,6a1,1,0,0,1-1.379.029L6.479,12.961a1,1,0,0,1,1.412-1.416Z"
                  transform="translate(-6.188 -11.246)"
                />
              </svg>
            </span>
          </li>
          <li> Upload Files</li>
        </ul>
        <div className="ButtonSection">
          <div className="headSection">
            <span className="black">
              {CtscanData ? CtscanData.intervaporid : ""}
            </span>
            <span className="gray">
              {CtscanData ? CtscanData.referenceid : ""}
            </span>
          </div>
          <div>
            <Button
              className="Savebutton"
              onClick={this.savePreliminary}
              style={{
                display:
                  this.state.files || this.state.treatmentfile
                    ? "block"
                    : "none",
              }}
            >
              Save
            </Button>
          </div>
        </div>
        <div
          // background:"yellow"
          style={{ margin: "0px" }}
          className="UploadCTScanSection"
        >
          <div
            className="patiendDataTreatment"
            // style={{
            //   display: "flex",
            //   height: "auto",
            //   width: "100%",
            // }}
          >
            {/* background: "orange", */}
            <div>
              <div>
                <h4>CT Scan File</h4>
                <div className="fileData">
                  <span>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="62.65"
                      height="68.208"
                      viewBox="0 0 62.65 68.208"
                    >
                      <g
                        id="Group_517"
                        data-name="Group 517"
                        transform="translate(-174 -350)"
                      >
                        <path
                          id="Path_120"
                          data-name="Path 120"
                          d="M3.031,0H38.143L50.019,12.944V65.177a3.031,3.031,0,0,1-3.031,3.031H3.031A3.031,3.031,0,0,1,0,65.177V3.031A3.031,3.031,0,0,1,3.031,0Z"
                          transform="translate(186.631 350)"
                          fill="#69bafe"
                        />
                        <rect
                          id="Rectangle_258"
                          data-name="Rectangle 258"
                          width="42"
                          height="19"
                          rx="9.5"
                          transform="translate(174 354)"
                          fill="#0071ce"
                        />
                        <text
                          id="DICOM"
                          transform="translate(183 367)"
                          fill="#fff"
                          fontSize="9"
                          fontFamily="KlavikaLight-OSF, Klavika"
                        >
                          <tspan x="0" y="0">
                            DICOM
                          </tspan>
                        </text>
                        <path
                          id="Path_121"
                          data-name="Path 121"
                          d="M0,0,12.126,13.136H3.537A3.537,3.537,0,0,1,0,9.6Z"
                          transform="translate(224.524 350)"
                          fill="#0071ce"
                        />
                        <g
                          id="Icon_feather-refresh-cw"
                          data-name="Icon feather-refresh-cw"
                          transform="translate(201.788 384.357)"
                        >
                          <path
                            id="Path_122"
                            data-name="Path 122"
                            d="M30.857,6v5.357H25.5"
                            transform="translate(-11.214 -5.109)"
                            fill="none"
                            stroke="#fff"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="3"
                          />
                          <path
                            id="Path_123"
                            data-name="Path 123"
                            d="M1.5,26.357V21H6.857"
                            transform="translate(-1.5 -11.18)"
                            fill="none"
                            stroke="#fff"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="3"
                          />
                          <path
                            id="Path_124"
                            data-name="Path 124"
                            d="M3.741,9.859a8.036,8.036,0,0,1,13.26-3l4.143,3.893M1.5,14.323l4.143,3.893a8.036,8.036,0,0,0,13.26-3"
                            transform="translate(-1.5 -4.503)"
                            fill="none"
                            stroke="#fff"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="3"
                          />
                        </g>
                      </g>
                    </svg>
                  </span>
                  <div className="DicomFileviewSection">
                    <ul>
                      <li>{CtscanData ? CtscanData.filename : ""}</li>
                      <li>
                        Created on{" "}
                        {CtscanData ? formatDate(CtscanData.createdon) : ""}
                      </li>
                    </ul>
                    <ul>
                      <li>
                        {" "}
                        {this.state.progressValue &&
                        this.state.progressValue.ctscan ? (
                          <div className="downloadlink">
                            {/* <SystemUpdateAltIcon /> */}
                            <CircularProgressWithLabel /> Downloading
                          </div>
                        ) : (
                          <a
                            className="downloadlink"
                            onClick={(e) =>
                              this.fileDownload(
                                e,
                                CtscanData ? CtscanData.filepath : "",
                                "ctscan",
                                CtscanData ? CtscanData.filename : ""
                              )
                            }
                          >
                            <SystemUpdateAltIcon /> Download
                          </a>
                        )}
                      </li>
                      {this.state.isActionPermission ? (
                        <li>
                          <div
                            onClick={this.handleModal}
                            className="deletelink"
                            id="ctscan"
                          >
                            <span>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                height="16px"
                                viewBox="-40 0 427 427.00131"
                                width="16px"
                              >
                                <path d="m232.398438 154.703125c-5.523438 0-10 4.476563-10 10v189c0 5.519531 4.476562 10 10 10 5.523437 0 10-4.480469 10-10v-189c0-5.523437-4.476563-10-10-10zm0 0" />
                                <path d="m114.398438 154.703125c-5.523438 0-10 4.476563-10 10v189c0 5.519531 4.476562 10 10 10 5.523437 0 10-4.480469 10-10v-189c0-5.523437-4.476563-10-10-10zm0 0" />
                                <path d="m28.398438 127.121094v246.378906c0 14.5625 5.339843 28.238281 14.667968 38.050781 9.285156 9.839844 22.207032 15.425781 35.730469 15.449219h189.203125c13.527344-.023438 26.449219-5.609375 35.730469-15.449219 9.328125-9.8125 14.667969-23.488281 14.667969-38.050781v-246.378906c18.542968-4.921875 30.558593-22.835938 28.078124-41.863282-2.484374-19.023437-18.691406-33.253906-37.878906-33.257812h-51.199218v-12.5c.058593-10.511719-4.097657-20.605469-11.539063-28.03125-7.441406-7.421875-17.550781-11.5546875-28.0625-11.46875h-88.796875c-10.511719-.0859375-20.621094 4.046875-28.0625 11.46875-7.441406 7.425781-11.597656 17.519531-11.539062 28.03125v12.5h-51.199219c-19.1875.003906-35.394531 14.234375-37.878907 33.257812-2.480468 19.027344 9.535157 36.941407 28.078126 41.863282zm239.601562 279.878906h-189.203125c-17.097656 0-30.398437-14.6875-30.398437-33.5v-245.5h250v245.5c0 18.8125-13.300782 33.5-30.398438 33.5zm-158.601562-367.5c-.066407-5.207031 1.980468-10.21875 5.675781-13.894531 3.691406-3.675781 8.714843-5.695313 13.925781-5.605469h88.796875c5.210937-.089844 10.234375 1.929688 13.925781 5.605469 3.695313 3.671875 5.742188 8.6875 5.675782 13.894531v12.5h-128zm-71.199219 32.5h270.398437c9.941406 0 18 8.058594 18 18s-8.058594 18-18 18h-270.398437c-9.941407 0-18-8.058594-18-18s8.058593-18 18-18zm0 0" />
                                <path d="m173.398438 154.703125c-5.523438 0-10 4.476563-10 10v189c0 5.519531 4.476562 10 10 10 5.523437 0 10-4.480469 10-10v-189c0-5.523437-4.476563-10-10-10zm0 0" />
                              </svg>
                            </span>{" "}
                            Delete
                          </div>
                        </li>
                      ) : (
                        ""
                      )}
                    </ul>
                  </div>
                  <div className="commentSection">
                    {/* {CtscanData ?CtscanData.comments ?} */}
                    <span>Comments</span>
                    <p>{CtscanData ? CtscanData.comments : ""}</p>
                  </div>
                </div>
              </div>
              {/**************** Preliminary Analysis view *************/}
              <div>
                {CtscanData && CtscanData.preliminaryanalysispath ? (
                  <React.Fragment>
                    <div className="preanalysis">
                      <h3>Preliminary Analysis</h3>
                    </div>
                    <div>
                      <DownloadAndDelete
                        createdOn={
                          CtscanData ? formatDate(CtscanData.createdon) : ""
                        }
                        fileDownload={this.fileDownload}
                        filepath={
                          CtscanData ? CtscanData.preliminaryanalysispath : ""
                        }
                        type="preAnalysis"
                        filename={CtscanData ? CtscanData.preliminary : ""}
                        handleModal={this.handleModal}
                        id="preliminaryanalysispath"
                        isActionPermission={this.state.isActionPermission}
                        comments={
                          CtscanData
                            ? CtscanData.preliminaryanalysiscomments
                            : ""
                        }
                        progressValue={
                          this.state.progressValue &&
                          this.state.progressValue.preliminary
                            ? this.state.progressValue.preliminary
                            : ""
                        }
                      />
                    </div >
                    <div className="preanalysis" >
                      {/* Send Notification Button */}
                    {!this.state.isActionPermission &&
                      CtscanData &&
                      !CtscanData.treatmentplanpath ? (
                        <Button onClick={this.sendNotificaion}>
                          {/* <Button onClick={this.sendNotificaionModal}> */}
                          Request IP3
                        </Button>
                      ) : (
                        ""
                      )}
                      {/*  */}
                    </div>
                  </React.Fragment>
                ) : this.state.isActionPermission ? (
                  <React.Fragment>
                    <div className="preanalysis-upload">
                      <h3>Preliminary Analysis</h3>
                      {CtscanData && CtscanData.preliminaryanalysispath ? (
                        ""
                      ) : (
                        <FormControlLabel
                          control={
                            <Checkbox
                              name={"sendEmail"}
                              id="preliminary"
                              checked={this.state.sendEmail}
                              onChange={this.handleCheck}
                              color="primary"
                            />
                          }
                          label={"Send Email Notification"}
                        />
                      )}
                    </div>
                    <Dropzone fileData={this.fileData} />
                    <TextField
                      style={{ width: "100%" }}
                      name={"preliminaryComment"}
                      onChange={this.handleCommentTextField}
                      multiline
                      margin="normal"
                      value={
                        this.state.preliminaryComment
                          ? this.state.preliminaryComment
                          : ""
                      }
                      label="Comments"
                    />
                  </React.Fragment>
                ) : (
                  ""
                )}
              </div>
              {/* IP3 Analysis */}
              <div>
                {CtscanData && CtscanData.treatmentplanpath ? (
                  <React.Fragment>
                    <h3 className="blue">IP3 Treatment Plan</h3>
                    <DownloadAndDelete
                      createdOn={
                        CtscanData ? formatDate(CtscanData.createdon) : ""
                      }
                      fileDownload={this.fileDownload}
                      filepath={CtscanData ? CtscanData.treatmentplanpath : ""}
                      type="treatmentPlan"
                      filename={this.state.treatmentfileName}
                      handleModal={this.handleModal}
                      id="treatmentplanpath"
                      isActionPermission={this.state.isActionPermission}
                      comments={
                        CtscanData ? CtscanData.treatmentplancomments : ""
                      }
                      progressValue={
                        this.state.progressValue && this.state.progressValue.ip3
                          ? this.state.progressValue.ip3
                          : ""
                      }
                    />
                  </React.Fragment>
                ) : CtscanData &&
                  CtscanData.preliminaryanalysispath &&
                  this.state.isActionPermission ? (
                  <div>
                    <div className="ip3-upload">
                      <h3>IP3 Treatment Plan</h3>
                      {CtscanData && CtscanData.treatmentplanpath ? (
                        ""
                      ) : (
                        <FormControlLabel
                          control={
                            <Checkbox
                              name={"sendEmail"}
                              id="ip3"
                              checked={this.state.sendEmail}
                              onChange={this.handleCheck}
                              color="primary"
                            />
                          }
                          label={"Send Email Notification"}
                        />
                      )}
                    </div>
                    <Dropzone fileData={this.fileTreatmentData} />
                    <TextField
                      style={{ width: "100%" }}
                      name={"requestip3comments"}
                      onChange={this.handleCommentTextField}
                      multiline
                      margin="normal"
                      value={
                        this.state.requestip3comments
                          ? this.state.requestip3comments
                          : ""
                      }
                      label="Comments"
                    />
                  </div>
                ) : (
                  ""
                )}
              </div>
            </div>
            {/* {this.state.isActionPermission ? ( */}
            <div className="treatmentHistory">
              <TreatMentHistorySection
                Permission={false}
                Add={this.state.treatmentHistoryAddOpen}
                historyData={this.state.treatmentHistoryData}
                ctscanid={this.props.location.state && this.props.location.state.id}
                renderTreatmentHistoryEdit={this.renderTreatmentHistoryEdit}
                getTreatmentHistory={this.getTreatmentHistory}
              />
            </div>
          </div>

          {/* **********************DELETE DIALOG****************** */}
          <Dialog
            open={this.state.deleteModalOpen}
            onClose={this.handleClose}
            aria-labelledby="responsive-dialog-title"
          >
            <DialogTitle id="responsive-dialog-title">Confirm</DialogTitle>
            <DialogContent>
              <DialogContentText>
                Are you sure you want to delete this item?
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button
                autoFocus
                onClick={this.handleModal}
                className="cancelbtn"
              >
                Cancel
              </Button>
              <Button
                onClick={this.deleteFile}
                autoFocus
                className="confirmbtn"
              >
                Confirm
              </Button>
            </DialogActions>
          </Dialog>
          {/* **********************END DELETE DIALOG****************** */}

          {/* Email Template Dialog for Notification */}
          {this.state.message ? (
            <Dialog
              open={this.state.isEmailModalDialog}
              onClose={this.emailModalClose}
              aria-labelledby="responsive-dialog-title"
            >
              <DialogTitle id="responsive-dialog-title">
                Review Email Contents{" "}
              </DialogTitle>
              <DialogContent>
                <DialogContentText>
                  <EmailTemplateEditor
                    setTemplateObject={this.setTemplateObject}
                    message={this.state.message}
                  />
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button
                  autoFocus
                  onClick={this.emailModalClose}
                  className="cancelbtn"
                >
                  Cancel
                </Button>
                <Button
                  onClick={() =>
                    this.setState({ sendAndSave: true }, () =>
                      this.savePreliminary()
                    )
                  }
                  autoFocus
                  className="confirmbtn"
                >
                  Send
                </Button>
              </DialogActions>
            </Dialog>
          ) : (
            ""
          )}
          {/* End of Email Template for Notification */}
          {/******* NOTIFICATION COMMENT MODAL ***********/}
          <Dialog
            open={this.state.notificationModalOpen}
            onClose={this.sendNotificaionModal}
            aria-labelledby="responsive-dialog-title"
          >
            <DialogTitle id="responsive-dialog-title">
              Treatment Plan Comment
            </DialogTitle>
            <DialogContent>
              <DialogContentText>
                <TextField
                  style={{ width: "100%" }}
                  name={"ip3comments"}
                  onChange={(e) =>
                    this.setState({ ip3requestcomment: e.target.value })
                  }
                  multiline
                  margin="normal"
                  value={
                    this.state.ip3requestcomment
                      ? this.state.ip3requestcomment
                      : ""
                  }
                />
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button
                autoFocus
                onClick={this.sendNotificaionModal}
                className="cancelbtn"
              >
                Cancel
              </Button>
              <Button
                onClick={this.sendNotificaion}
                autoFocus
                className="confirmbtn"
              >
                Send
              </Button>
            </DialogActions>
          </Dialog>
          {/******* END NOTIFICATION COMMENT MODAL ***********/}
        </div>
      </div>
    );
  }
}

export default EditPatient;
